module.exports = __webpack_public_path__ + "img/h-banner.42a10ee1.png";